module.exports = __webpack_public_path__ + "img/tu_biao.ce563744.png";